<template>
  <div>
    <Drawer placement="left" title="审批流程详情" closable v-model="show" width="400px">
      <div class="mainview">

        <div v-for="(item1, index1) in flow_data" :key="index1">
          <div class="flow_list_title">----- {{ item1.title }} -----</div>
          <div v-for="(item, index) in item1.child" :key="index" class="huo_div">

            <div class="flow_card">
              <div class="user_avatar_div">
                <img fit="cover" class="user_avatar" :src="item.avatar" alt="" />
                <div>
                  <div class="user_name">{{ item.name }}</div>
                  <div class="audit_status-1" v-if="item.status == -1">
                    <Icon type="md-arrow-round-up" /> 发起申请
                  </div>
                  <div class="audit_status0" v-if="item.status == 0">
                    <Icon type="ios-clock-outline" /> 待审批
                    <span class="cuoyixia" @click="click_urge(item)">
                      <Icon type="ios-notifications-outline" size="16" />催一下
                    </span>

                  </div>
                  <div class="audit_status1" v-if="item.status == 1">
                    <Icon type="md-checkmark-circle" /> 已通过
                  </div>
                  <div class="audit_status2" v-if="item.status == 2">
                    <Icon type="ios-close-circle" /> 不通过
                  </div>
                </div>
              </div>
              <div class="create_time" v-if="item.status != 0">{{ item.time }}</div>
            </div>
            <div class="huo" v-if="index < item1.child.length - 1">
              或
            </div>
          </div>
          <div class="card_bottom_line_div" v-if="index1 < flow_data.length - 1">
            <div class="card_bottom_line">
            </div>
          </div>
        </div>
      </div>
    </Drawer>

    <Modal v-model="urge_show" title="流程催促" :mask-closable="false" :footer-hide="true" width="400">
      <div>
        <div>
          温馨小提示：请不要短时间发送多次催促短信，避免造成骚扰，容易挨揍哟😁~
        </div>
        <div class="urge_btn">
          <Button type="primary" @click="urge">我知悉，发送催促短信</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http } from "@/utils/http.js";

export default {
  name: "view_flow",
  data() {
    return {
      show: false,
      urge_show: false,
      flow_data: [
        // {
        //   name: "张三三",
        //   avatar:
        //     "https://img0.baidu.com/it/u=2314829636,2475305228&fm=253&fmt=auto&app=120&f=JPEG?w=500&h=500",
        //   status: 1,
        //   time: "2025-01-01 10:10",
        // },
        // {
        //   name: "李四",
        //   avatar:
        //     "https://nimg.ws.126.net/?url=http%3A%2F%2Fdingyue.ws.126.net%2F2021%2F1208%2Fc2d79c9dj00r3s0ek0006c0004g004gc.jpg&thumbnail=125y125&quality=95&type=jpg",
        //   status: 2,
        //   time: "2025-02-01 10:10",
        // },
        // {
        //   name: "李四",
        //   avatar:
        //     "https://nimg.ws.126.net/?url=http%3A%2F%2Fdingyue.ws.126.net%2F2021%2F1208%2Fc2d79c9dj00r3s0ek0006c0004g004gc.jpg&thumbnail=125y125&quality=95&type=jpg",
        //   status: 0,
        //   time: "2025-02-01 10:10",
        // },
        // {
        //   name: "李四",
        //   avatar:
        //     "https://nimg.ws.126.net/?url=http%3A%2F%2Fdingyue.ws.126.net%2F2021%2F1208%2Fc2d79c9dj00r3s0ek0006c0004g004gc.jpg&thumbnail=125y125&quality=95&type=jpg",
        //   status: 0,
        //   time: "2025-02-01 10:10",
        // },
      ],
    };
  },
  methods: {

    click_urge(item) {
      this.urge_show = true
      this.current_urge_item = item
    },
    urge() {
      console.log('点击1232')
      
      var item = this.current_urge_item

      var urge_user_id = item.create_user_id 
      var audit_user_id = item.user_id
      var flow_name = item.flow_name

      var that = this;
      var obj = {
        urge_user_id: urge_user_id,
        audit_user_id: audit_user_id,
        flow_name:flow_name
      };
      http("post", process.env.VUE_APP_HOST + "/finance/invoice/jiesuan_urge", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    open(flow_data) {
      this.show = true;
      this.flow_data = flow_data;
    },
  },
};
</script>

<style scoped>
.urge_btn{
  display: flex;
  justify-content: center;
  padding:20px;
}

.flow_list_title {
  text-align: center;
  font-size: 12px;
  color: #dfdfdf;
}

.flow_list {
  display: flex;
}

.huo {
  margin: 3px 10px;
  color: #ccc;
  padding: 0 10px;

}

.huo_div {}

.mainview {
  height: calc(100vh - 90px);
  overflow: auto;
}

.card_bottom_line_div {
  padding: 20px 0 5px 25px;
}

.card_bottom_line {
  width: 2px;
  height: 40px;
  background: #aec2d6;
}

.create_time {
  color: #ccc;
  font-size: 13px;
}

.cuoyixia {
  color: #ccc;
  cursor: pointer;
  margin-left: 20px;
  font-size: 13px;
  float: right;
}

.cuoyixia:hover {
  color: #ff7a2c
}

.flow_card {
  display: flex;
  justify-content: space-between;
}

.audit_status-1 {
  margin-left: 10px;
  color: #1692ff;
  margin-top: 5px;
}

.audit_status0 {
  margin-left: 10px;
  color: #ccc;
  margin-top: 5px;
  align-items: center;
}

.audit_status1 {
  margin-left: 10px;
  color: #10c03c;
  margin-top: 5px;
}

.audit_status2 {
  margin-left: 10px;
  margin-top: 5px;
  color: #ff2b0f;
}

.user_name {
  margin-top: 2px;
  font-size: 14px;
  margin-left: 10px;
}

.user_avatar_div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.user_avatar {
  border-radius: 5px;
  width: 50px;
  height: 50px;
  border: 1px solid #ececec;
}
</style>
